var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSystemData = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0976 14C22.0976 18.4693 18.4703 22.0967 14.001 22.0967C9.5316 22.0967 6.80303 17.5949 6.80303 17.5949M6.80303 17.5949H10.4627M6.80303 17.5949V21.6432M5.9043 14C5.9043 9.53063 9.49922 5.90332 14.001 5.90332C19.4014 5.90332 22.0976 10.4051 22.0976 10.4051M22.0976 10.4051V6.35673M22.0976 10.4051H18.5027",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSystemData);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-system-data.83f91c9623b9d99166e88561f2db5097.svg";